import FieldTypesEnum from "../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import IobLineItem from "./IobLineItem";

class IobLineItemOther extends IobLineItem {
  static NameOfTheIdField() {
    return "IoblineItemId";
  }

  static FieldsToShowInDataTable() {
    return [
      { label: "Id", orderById: "IoblineItemId", data: "IoblineItemId", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 70 },
      { label: "Type", orderById: "Type", data: "Type" },
      { label: "Amount", orderById: "Amount", data: "Amount" },
      { label: "Paid", orderById: "AmountPaid", data: "AmountPaid" },
      { label: "Description", orderById: "Description", data: "Description" },
      { label: " ", orderById: "", data: IobLineItem.getActionsContent, type: FieldTypesEnum.ActionButton, className: "text-center" },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: "General",
      tabLabel: "General",
      icon: "fa-solid fa-home",
      data: [
        { name: "IoblineItemId", label: "IOB Invoice" },
        { name: "Type", label: "Type" },
        { name: "Amount", label: "Amount" },
        { name: "CurrencyName", label: "Currency" },
        { name: "Description", label: "Description", width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
  ];
}
export default IobLineItemOther;
